import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class AnimationService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService) { }

  getTitle = (): string => 'Animation';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'animation/0', 'title': 'FadeIn Left', 'theme': 'layout1' },
      { 'url': 'animation/1', 'title': 'FadeIn Up', 'theme': 'layout2' },
      { 'url': 'animation/2', 'title': 'BounceIn', 'theme': 'layout3' },
      { 'url': 'animation/3', 'title': 'ZoomIn', 'theme': 'layout4' },
      { 'url': 'animation/4', 'title': 'BounceIn Left', 'theme': 'layout5' },
      { 'url': 'animation/5', 'title': 'FadeIn', 'theme': 'layout6' },
      { 'url': 'animation/6', 'title': 'BounceIn Right And Left And ZoomIn', 'theme': 'layout7' },
      { 'url': 'animation/7', 'title': 'SlideIn Left', 'theme': 'layout8' },
      { 'url': 'animation/8', 'title': 'SlideIn Up And ZoomIn', 'theme': 'layout9' },
      { 'url': 'animation/9', 'title': 'FadeIn Right', 'theme': 'layout10' }

    ];
  }

  getDataForTheme = (menuItem: any): any => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'FadeIn Left',
      'items': [
        {
          'id': 1,
          'title': 'Porsche Taycan',
          "isChecked": false,
          'image': 'assets/imgs/avatar/1.jpg'
        },
        {
          'id': 2,
          'title': 'Porsche Taycan Turbo',
          "isChecked": true,
          'image': 'assets/imgs/avatar/2.jpg'
        },
        {
          'id': 3,
          'title': 'Mercedes-AMG CLA 45',
          "isChecked": false,
          'image': 'assets/imgs/avatar/3.jpg'
        },
        {
          'id': 4,
          'title': 'Volkswagen Golf GTI',
          "isChecked": false,
          'image': 'assets/imgs/avatar/4.jpg'
        },
        {
          'id': 5,
          'title': 'Hyundai Veloster N',
          "isChecked": true,
          'image': 'assets/imgs/avatar/5.jpg'
        },
        {
          'id': 6,
          'title': 'Ford Mustang Mach 1',
          "isChecked": false,
          'image': 'assets/imgs/avatar/6.jpg'
        }
      ]
    }
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'FadeIn Up',
      'headerImage': 'assets/imgs/background/1.jpg',
      'title': 'Best Sports Cars',
      'items': [
        {
          'id': 1,
          'title': 'Best Sport Sedans',
          'image': 'assets/imgs/avatar/11.jpg',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
        },
        {
          'id': 2,
          'title': 'Best Hot Hatches',
          'image': 'assets/imgs/avatar/12.jpg',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
        },
        {
          'id': 3,
          'title': 'Best Sports Convertibles',
          'image': 'assets/imgs/avatar/10.jpg',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
        },
        {
          'id': 4,
          'title': 'Best Sports Coupes',
          'image': 'assets/imgs/avatar/9.jpg',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
        },
        {
          'id': 5,
          'title': 'Best Muscle Cars',
          'image': 'assets/imgs/avatar/1.jpg',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
        },
        {
          'id': 6,
          'title': 'Best Supercars',
          'image': 'assets/imgs/avatar/2.jpg',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
        },
        {
          'id': 7,
          'title': 'Best Roadsters',
          'image': 'assets/imgs/avatar/11.jpg',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
        }
      ]
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'BounceIn',
      'items': [
        {
          'id': 1,
          "title": "Mercedes-AMG GT R Roadster",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/1.jpg",
          "details": "Best Hot Hatches",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 2,
          "title": "Mercedes-AMG GT Roadster",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/2.jpg",
          "details": "Best Sport Sedans",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 3,
          "title": "BMW Z4 Roadster",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/3.jpg",
          "details": "Best Sports Convertibles",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 4,
          "title": "Porsche 911 Turbo Cabriolet",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/1.jpg",
          "details": "Best Sports Coupes",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 5,
          "title": "Audi R8 Spyder",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/9.jpg",
          "details": "Best Muscle Cars",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 6,
          "title": "Audi R8 Coupe",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/10.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 7,
          "title": "Ford Mustang Mach 1",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/11.jpg",
          "details": "Best Supercars",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        },
        {
          'id': 8,
          "title": "Ford Mustang Bullitt",
          "description": "Amazing New Place",
          "image": "assets/imgs/avatar/12.jpg",
          "details": "Best Roadsters",
          "icon": "location",
          'iconLike': 'icon-thumb-up',
          'iconFavorite': 'icon-heart',
          'iconShare': 'icon-share-variant'
        }
      ]
    };
  }

  //* Data Set for page 4
  getDataForLayout4 = (): any => {
    return {
      'toolbarTitle': 'ZoomIn',
      'items': [
        {
          'id': 1,
          'title': 'Best Muscle Cars',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 2,
          'title': 'Best Sports Coupes',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/6.jpg',
        },
        {
          'id': 3,
          'title': 'Best Sports Convertibles',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/1.jpg',
        },
        {
          'id': 4,
          'title': 'Best Hot Hatches',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/4.jpg',
        },
        {
          'id': 5,
          'title': 'Best Sport Sedans',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/2.jpg',
        },
      ]
    };
  }

  //* Data Set for page 5
  getDataForLayout5 = (): any => {
    return {
      'toolbarTitle': 'BounceIn Left',
      'items': [
        {
          'id': 1,
          "title": "Mercedes-AMG GT R Roadster",
          "image": "assets/imgs/avatar/8.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 2,
          "title": "Mercedes-AMG GT Roadster",
          "image": "assets/imgs/avatar/7.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 3,
          "title": "Ford Mustang Bullitt",
          "image": "assets/imgs/avatar/6.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 4,
          "title": "BMW M8 Coupe",
          "image": "assets/imgs/avatar/5.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 5,
          "title": "Ford Mustang Shelby GT500",
          "image": "assets/imgs/avatar/12.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 6,
          "title": "Audi R8 Coupe",
          "image": "assets/imgs/avatar/11.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 7,
          "title": "Mercedes-AMG E53 Coupe",
          "image": "assets/imgs/avatar/10.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        },
        {
          'id': 8,
          "title": "BMW Z4 Roadstern",
          "image": "assets/imgs/avatar/9.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location"
        }
      ]
    }
  }

  //* Data Set for page 6
  getDataForLayout6 = (): any => {
    return {
      'toolbarTitle': 'FadeIn',
      'items': [
        {
          'id': 1,
          'title': 'Best Roadsters',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/2.jpg',
        },
        {
          'id': 2,
          'title': 'Best Supercars',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/3.jpg',
        },
        {
          'id': 3,
          'title': 'Best Muscle Cars',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/6.jpg',
        },
        {
          'id': 4,
          'title': 'Best Sports Coupes',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 5,
          'title': 'Best Sports Convertibles',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/7.jpg',
        },
      ]
    }
  }

  //* Data Set for page 7
  getDataForLayout7 = (): any => {
    return {
      'toolbarTitle': 'BounceIn Right And Left And ZoomIn',
      'headerImage': 'assets/imgs/background/12.jpg',
      'title': 'How to Pick the Best Bike for You',
      'items': [
        {
          'id': 1,
          'title': 'Road Bikes',
          'seeAll': 'See All',
          'items': [
            {
              'id': 1,
              'title': 'Fitness Bikes',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/11.jpg',
            },
            {
              'id': 2,
              'title': 'Touring Bikes',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/10.jpg',
            },
            {
              'id': 3,
              'title': 'Adult Tricycles',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/8.jpg',
            },
            {
              'id': 4,
              'title': 'Tandem Bikes',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/9.jpg',
            }
          ]
        },
        {
          'id': 2,
          'title': 'Cyclocross Bikes',
          'seeAll': 'See All',
          'items': [
            {
              'id': 1,
              'title': 'City Bikes',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/9.jpg',
            },
            {
              'id': 2,
              'title': 'BMX Bikes',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/8.jpg',
            },
            {
              'id': 3,
              'title': 'Folding Bikes',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/10.jpg',
            },
            {
              'id': 4,
              'title': 'Recumbent Bikes',
              'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
              'image': 'assets/imgs/background/11.jpg',
            }
          ]
        },
      ]
    }
  }

  //* Data Set for page 8
  getDataForLayout8 = (): any => {
    return {
      'toolbarTitle': 'SlideIn Left',
      'allComments': '2121 Comments',
      'items': [
        {
          'id': 1,
          'image': 'assets/imgs/avatar/17.jpg',
          'title': 'Erica Romaguera',
          'time': '18 August',
          'description': 'If you could have any kind of pet, what would you choose?',
          'buttonLike': '743',
          'buttonDislike': '33',
          'iconLike': 'thumbs-up',
          'iconDislike': 'thumbs-down',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 2,
          'image': 'assets/imgs/avatar/18.jpg',
          'title': 'Caleigh Jerde',
          'time': '18 August',
          'description': 'If you could learn any language, what would you choose?',
          'buttonLike': '743',
          'buttonDislike': '33',
          'iconLike': 'thumbs-up',
          'iconDislike': 'thumbs-down',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 3,
          'image': 'assets/imgs/avatar/19.jpg',
          'title': 'Lucas Schultz',
          'time': '18 August',
          'description': 'Life is about making an impact, not making an income.',
          'buttonLike': '743',
          'buttonDislike': '33',
          'iconLike': 'thumbs-up',
          'iconDislike': 'thumbs-down',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 4,
          'image': 'assets/imgs/avatar/20.jpg',
          'title': 'Carole Marvin',
          'time': '18 August',
          'description': `I\’ve learned that people will forget what you said,
                   people will forget what you did, but people will never forget how you made them feel`,
          'buttonLike': '743',
          'buttonDislike': '33',
          'iconLike': 'thumbs-up',
          'iconDislike': 'thumbs-down',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 5,
          'image': 'assets/imgs/avatar/21.jpg',
          'title': 'Doriana Feeney',
          'time': '18 August',
          'description': 'Definiteness of purpose is the starting point of all achievement.',
          'buttonLike': '743',
          'buttonDislike': '33',
          'iconLike': 'thumbs-up',
          'iconDislike': 'thumbs-down',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            }
          ],
        },
        {
          'id': 6,
          'image': 'assets/imgs/avatar/22.jpg',
          'title': 'Nia Gutkowski',
          'time': '18 August',
          'description': 'Life is what happens to you while you’re busy making other plans',
          'buttonLike': '743',
          'buttonDislike': '33',
          'iconLike': 'thumbs-up',
          'iconDislike': 'thumbs-down',
          "iconsStars": [
            {
              "icon": "star",
            },
            {
              "icon": "star"
            },
            {
              "icon": "star-outline"
            },
            {
              "icon": "star-outline"
            },
            {
              "icon": "star-outline"
            }
          ],
        }
      ]
    }
  }

  //* Data Set for page 9
  getDataForLayout9 = (): any => {
    return {
      'toolbarTitle': 'SlideIn Up And ZoomIn',
      'image': 'assets/imgs/avatar/21.jpg',
      'title': 'Carolyn Guerrero',
      'subtitle': 'From New York',
      'description': 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.',
      'button': 'Follow',
      'icon': "chatbubble-ellipses",
      'followers': 'Followers',
      'valueFollowers': '439',
      'following': 'Following',
      'valueFollowing': '297',
      'posts': 'Posts',
      'valuePosts': '43',
      'items': [
        {
          'id': 1,
          'category': 'Cars',
          'backgroundCard': 'assets/imgs/background/5.jpg',
          'title': 'Mercedes-AMG S63 Coupe',
          'like': {
            'icon': 'thumbs-up',
            'text': 'Like',
            'number': '4',
            'isActive': true
          },
          'comment': {
            'icon': 'chatbubbles',
            'number': '4',
            'text': 'Comments',
            'isActive': false
          }
        },
        {
          'id': 2,
          'category': 'Cars',
          'backgroundCard': 'assets/imgs/background/6.jpg',
          'title': 'Ford Mustang Shelby GT500o',
          'like': {
            'icon': 'thumbs-up',
            'text': 'Like',
            'number': '4',
            'isActive': true
          },
          'comment': {
            'icon': 'chatbubbles',
            'number': '4',
            'text': 'Comments',
            'isActive': false
          }
        },
        {
          'id': 3,
          'category': 'Cars',
          'backgroundCard': 'assets/imgs/background/7.jpg',
          'title': 'Porsche 911 Turbo Cabriolet',
          'like': {
            'icon': 'thumbs-up',
            'text': 'Like',
            'number': '4',
            'isActive': true
          },
          'comment': {
            'icon': 'chatbubbles',
            'number': '4',
            'text': 'Comments',
            'isActive': false
          }
        }
      ]
    }
  }

  //* Data Set for page 10
  getDataForLayout10 = (): any => {
    return {
      'toolbarTitle': 'FadeIn Right',
      'items': [
        {
          'id': 1,
          'avatarTitle': 'Best Hot Hatches',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/20.jpg',
          'title': '45 Park Lane',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/7.jpg',
        },
        {
          'id': 2,
          'avatarTitle': 'Best Supercars',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/23.jpg',
          'title': 'Encore Macau',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 3,
          'avatarTitle': 'Best Muscle Cars',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/21.jpg',
          'title': 'Bulgari Hotel London',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/6.jpg',
        },
        {
          'id': 4,
          'avatarTitle': 'Best Sports Coupes',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/22.jpg',
          'title': 'Belmond El Encanto',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/5.jpg',
        },
        {
          'id': 5,
          'avatarTitle': 'Best Roadsters',
          'avatarSubitle': 'Latest Tenant',
          'avatar': 'assets/imgs/avatar/24.jpg',
          'title': 'The Alpina Gstaad',
          'subtitle': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/background/3.jpg',
        },
      ]
    }
  }


  load(item: any): Observable<any> {
    const that = this;
    that.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('animation/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            that.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            that.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        that.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
